module.exports = __webpack_public_path__ + "static/ballantinesEF-6a5f64446f708531a101277efae73ef6.woff2";